module.exports = __webpack_public_path__ + "img/plane.7fe18e7a.svg";